/* eslint-disable quotes */
import ApiService from "./api.service";
// import ApiMockService from "./api.mock.service"

const IlongameService = {
  getAllQuestionWithAnswers: async function (params = {}, lang = null) {
    const response = await ApiService._get("api/ilongame/questions-with-answers", params, lang);
    return response.data;
  },

  getQuestionWithAnswersById: async function (id, lang = null) {
    const response = await ApiService._get(`api/ilongame/questions-with-answers/${id}?withTranslations=true`, lang);
    return response.data;
  },

  createQuestionWithAnswers: async function (params = {}, lang = null) {
    const response = await ApiService.post("api/ilongame/questions-with-answers", params, lang);
    return response.data;
  },

  updateQuestionWithAnswers: async function (id, params = {}, lang = null) {
    const response = await ApiService.put(`api/ilongame/questions-with-answers/${id}`, params, lang);
    return response.data;
  },

  deleteQuestionWithAnswers: async function (id, lang = null) {
    const response = await ApiService.delete(`api/ilongame/questions-with-answers/${id}`, lang);
    return response.data;
  },
};

export default IlongameService;
